import { useMemo } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import type { CustomAttribute } from '~/shared/data-contract/custom-attribute';

import { COLUMN_LABEL_KEYS, customAttributeLabelKey, HIDEABLE_BASE_COLUMN_IDS } from '../columns';

export type HideableColumn = {
    readonly id: string;
    readonly label: string;
};

export const useHideableColumns = (customAttributes: readonly CustomAttribute[]): readonly HideableColumn[] => {
    const translate = useTranslate();

    return useMemo(
        () => [
            ...HIDEABLE_BASE_COLUMN_IDS.map((columnId) => ({
                id: columnId,
                label: translate(COLUMN_LABEL_KEYS[columnId]),
            })),
            ...customAttributes.map((attribute) => ({
                id: attribute.key,
                label: translate(customAttributeLabelKey(attribute.name), { defaultValue: attribute.name }),
            })),
        ],
        [customAttributes, translate],
    );
};
